import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Home from '../Home/Home';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const PaymentSuccess = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const paymentID = searchParams.get('PayerID');
    const [transactionId, setTransactionId] = useState(null); // 👈 State for transaction ID
    const [openLoader, setOpenLoader] = useState(false);

    useEffect(() => {
        const captureOrder = async () => {
            setOpenLoader(true);
            const userId = Number(sessionStorage.getItem('userId'));
            const emailId = sessionStorage.getItem('emailId');
            const eventId = Number(sessionStorage.getItem('eventId'));
            const eventType = sessionStorage.getItem('eventType');

            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/payment/order/${token}/capture`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        userId,
                        eventId,
                        emailId,
                        eventType,
                        paymentID,
                        paymentConfirmation: true,
                    }),
                });

                if (!res.ok) throw new Error('Failed to capture order');

                const data = await res.json();
                console.log('Capture success:', data);
                setTransactionId(data.id); // 👈 Save transaction ID from response
                setOpenLoader(false);
            } catch (error) {
                console.error('Error capturing order:', error);
                setOpenLoader(false);
            }
        };

        if (token) {
            captureOrder();
        }
    }, [token]);

    return (
        <Home>
            <Backdrop 
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} 
                open={openLoader}>
                    <CircularProgress color="inherit" />
            </Backdrop>
            <div style={{ padding: '2rem', textAlign: 'center' }}>
                <h2>Payment Successfully processed!</h2>
                <p>Your PayPal transaction ID is <strong>{transactionId || 'loading...'}</strong>.</p>
                <p>Thank you for your payment. A confirmation email has been sent to your email provided by you during registration. You can now return to the homepage.</p>
                <a href="/" style={{ marginTop: '1rem', display: 'inline-block', textDecoration: 'underline' }}>
                    Go back to Home
                </a>
            </div>
        </Home>
    );
};

export default PaymentSuccess;
